import { styled, Box } from '@mui/material';
const EventsList = styled(Box)(({ theme }) => ({
    overflow: 'auto',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12,
}));
export { EventsList };
